import echarts from "echarts";

var dataAxis = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  // "01",
];
var data = [
  4979,
  2245,
  5091,
  5411,
  5682,
  6611,
  4697,
  3642,
  3954,
  4073,
  6290,
  9713,
  // 2317,
];
var yMax = 12000;
var dataShadow = [];

for (var i = 0; i < data.length; i++) {
  dataShadow.push(yMax);
}

export default {
  title: {
    text: "2019年国内新能源汽车锂电池装机量",
  },
  grid: {
    top: 180,
  },
  tooltip: {
    trigger: "item",
  },
  xAxis: {
    name: "月份",
    data: dataAxis,
    axisLabel: {
      inside: false,
    },
    axisTick: {
      show: true,
    },
    axisLine: {
      show: false,
    },
    z: 10,
  },
  yAxis: {
    name: "装机量/MWh",

    axisLabel: {
      textStyle: {},
    },
  },
  dataZoom: [
    {
      type: "inside",
    },
  ],
  series: [
    {
      // For shadow
      type: "bar",
      itemStyle: {
        color: "rgba(0,0,0,0.05)",
      },
      barGap: "-100%",
      barCategoryGap: "40%",
      data: dataShadow,
      animation: false,
    },
    {
      type: "bar",
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#83bff6" },
          { offset: 0.5, color: "#188df0" },
          { offset: 1, color: "#188df0" },
        ]),
      },
      emphasis: {
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#2378f7" },
            { offset: 0.7, color: "#2378f7" },
            { offset: 1, color: "#83bff6" },
          ]),
        },
      },
      data: data,
    },
  ],
};

// Enable data zoom when user click bar.
